export default __webpack_public_path__ + "static/analyticssvg-85bf8276c235dffe2dd9468663f2041b.svg";